import React from 'react'

export default function Container() {
  return (
    <div>
      <div className="container my-5">
        <h1 style={{fontFamily:'Montserrat, sans-serif',fontSize:'60px'}}>News on the GO!</h1>
        <p style={{fontFamily:'Unbounded, cursive'}} className='my-3'>News are an important part of our life. Some people cannot start their day without reading News. They are printed in various languages and even in local languages. News are delivered to our doorsteps every morning. News are one of the easiest methods of spreading news and information around the world. There might be those who read every single news article, irrespective of what they speak about. There are also people who read only what interests them. For some, it might be politics; for some, it might be sports; while for others, it might be technology. Though the number of people subscribing to printed News is reducing day by day, there are still some who prefer reading them rather than the digital versions of the news on their personal phones or laptops.</p>
        



      </div>
    </div>
  )
}
